import React, { createContext, useContext } from 'react';

export interface CartNudgeContextType {
  showNudge: () => void;
  hideNudge: () => void;
}

const CartNudgeContext = createContext<CartNudgeContextType | undefined>(undefined);

export const useCartNudge = () => {
  const context = useContext(CartNudgeContext);
  if (!context) {
    throw new Error('useCartNudge must be used within a CartNudgeProvider');
  }
  return context;
};

export default CartNudgeContext;
